import { createFileRoute } from "@tanstack/react-router";
import { onboardingListOptions, onboardingSearchSchema } from "@/features/users/onboarding-queries";
import { OnboardingPage } from "@/features/users/pages/onboarding-page";
export const Route = createFileRoute("/_authed/tenants/$slug/users/imports")({
  validateSearch: (raw: Record<string, unknown>) => onboardingSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ cursor: search.cursor }),
  loader: ({ context, deps }) => context.queryClient.ensureQueryData(onboardingListOptions(context.tenant.id, deps.cursor)),
  component: OnboardingPage,
});
